/**
 * RefusalState — a 403 shown as what it is (EXR-W1 W1-9: "refusals are refusals").
 *
 * A page whose read the server refused used to render its empty state ("No data"), which tells a person
 * there is nothing to do when in fact they may not look. The server's refusal body names the module and the
 * flag (`module_access_denied`: { module, required }); this says exactly that, and nothing the server did not.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Result } from 'antd';
import { ShieldOff } from 'lucide-react';

export const refusalText = (refusal) => {
  if (!refusal) return '';
  if (refusal.module && refusal.required) return `You do not hold ${refusal.required} access on “${refusal.module}”.`;
  return refusal.message || 'You do not have access to this.';
};

export default function RefusalState({ refusal, what, testId }) {
  return (
    <div data-testid={testId || 'refusal-state'} role="alert">
      <Result
        icon={<ShieldOff size={40} aria-hidden="true" />}
        title={what ? `Access refused: ${what}` : 'Access refused'}
        subTitle={`${refusalText(refusal)} Ask your administrator if your role should include it.`}
      />
    </div>
  );
}

RefusalState.propTypes = {
  refusal: PropTypes.shape({ module: PropTypes.string, required: PropTypes.string, message: PropTypes.string }),
  what: PropTypes.string,
  testId: PropTypes.string,
};
